import { Link } from 'react-router-dom';
import { mainSiteUrl } from '@/mocks/categories';

interface RelatedArticle {
  title: string;
  slug: string;
}

interface ArticleFooterProps {
  relatedArticles: RelatedArticle[];
}

export default function ArticleFooter({ relatedArticles }: ArticleFooterProps) {
  return (
    <section className="bg-background-100 rounded-2xl p-8 md:p-10 border border-background-200/60">
      <h2 className="font-heading text-2xl font-semibold text-foreground-900 mb-4">
        Continue Your CSSBuy Journey
      </h2>
      <p className="text-foreground-600 leading-relaxed mb-6 text-sm">
        Ready to put your knowledge into action? Browse our curated CSSBuy spreadsheet directory or explore more in-depth guides below. Do not forget to bookmark our <Link to="/" className="text-primary-600 hover:text-primary-700 underline">CSSSpreadsheet homepage</Link> for weekly updates.
      </p>

      {relatedArticles.length > 0 && (
        <div className="mb-6">
          <h3 className="text-sm font-semibold text-foreground-800 mb-3">Related Articles</h3>
          <div className="flex flex-wrap gap-2">
            {relatedArticles.map((ra) => (
              <Link
                key={ra.slug}
                to={ra.slug}
                className="inline-flex items-center px-4 py-2 rounded-full bg-white border border-background-200/60 text-sm text-foreground-700 hover:border-primary-300 hover:text-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                {ra.title}
                <i className="ri-arrow-right-line ml-1.5 text-xs"></i>
              </Link>
            ))}
          </div>
        </div>
      )}

      <div className="flex flex-col sm:flex-row gap-4">
        <a
          href={mainSiteUrl}
          target="_blank"
          rel="noopener nofollow"
          className="inline-flex items-center justify-center px-6 py-3 rounded-full bg-primary-500 text-white font-semibold text-sm hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
        >
          Browse Spreadsheets
          <i className="ri-arrow-right-up-line ml-2"></i>
        </a>
        <Link
          to="/"
          className="inline-flex items-center justify-center px-6 py-3 rounded-full border border-foreground-200 text-foreground-800 font-semibold text-sm hover:bg-foreground-50 transition-colors duration-200 whitespace-nowrap cursor-pointer"
        >
          <i className="ri-home-line mr-2"></i>
          Back to Homepage
        </Link>
      </div>
    </section>
  );
}